'use client';

import { useNuqsNextPagesRouterAdapter } from '../../chunk-NLCFEFLS.js';
import '../../chunk-JJE4GO42.js';
import '../../chunk-3RCMAOX7.js';
import { createAdapterProvider } from '../../chunk-SDEJ2M24.js';

// src/adapters/next/pages.ts
var NuqsAdapter = createAdapterProvider(useNuqsNextPagesRouterAdapter);

export { NuqsAdapter };
